<app-skip-round-new-modal [date]='this.date'></app-skip-round-new-modal>
@if (this.isDatePickerVisible) {
  <bs-datepicker-inline (bsValueChange)='this.onDateSelected($event)' [bsValue]='this.date' class='datePicker'></bs-datepicker-inline>
}
<div class='timelineToolbarContainer'>
  <div>
    <button class='btn btn-secondary' (click)='openModal("skipRoundCreationModal");'><i class="fas fa-plus"></i> New Round</button>&nbsp;
    <button (click)='this.onDeletedJobClicked()' class='btn btn-danger' data-toggle="tooltip" data-placement="top"
      title="Remove Job"><i class="fas fa-ban"></i></button> &nbsp;
      <button (click)='onApproveJobClicked()' class='btn btn-success' data-toggle="tooltip" data-placement="top"
        title="Approve Job"><i class="fas fa-check-circle"></i></button>&nbsp;
        <button class='btn btn-warning' (click)='onUnapproveJobClicked()' data-toggle="tooltip" data-placement="top"
          title="Unapprove Job"><i class="fas fa-undo"></i></button>
        </div>
        <div style='z-index:-1' id='dateSelector'>
          <div class="dateSelectorContainer">
            <button class="btn btn-primary" (click)='this.prevDay()'><i class="fas fa-chevron-left"></i></button>
            <div class="dateSelectorBox" (click)='this.isDatePickerVisible = !this.isDatePickerVisible'>
              <span><i class="fas fa-calendar-alt" style='font-size: 0.8rem'></i>&nbsp;&nbsp; {{ getFormattedDate() }}</span>
            </div>
            <button class="btn btn-primary" (click)='this.nextDay()'><i class="fas fa-chevron-right"></i></button>
          </div>
        </div>

        <div>
          <div class="form-group" style='margin-right: 8rem;z-index:-1' id='vehicleSelector'>
            <select class='form-control vehicleTypeSelector' (change)='this.onVehicleTypeChanged($event)'>
              <option value='-1'>All Vehicles</option>
              <option value='1'>Hook Lift</option>
              <option value='2'>Chain Lift</option>
            </select>
          </div>

          <div>
            <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input" id="skipShowSubcontractors" [ngModel]='this.isSubcontractorsVisible' (ngModelChange)='this.onSubToggleChanged($event)'>
              <label class="custom-control-label" for="skipShowSubcontractors"><strong>Show Subcontractors?</strong></label>
            </div>
          </div>
        </div>
      </div>
